var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headView',{attrs:{"loginShow":_vm.loginShow},on:{"getLoginShow":_vm.getLoginShow}}),(!_vm.isShow)?_c('search',{ref:"searchRef",attrs:{"is-lock-search":_vm.isLockSearch},on:{"getLoginShow":_vm.getLoginShow}}):_vm._e(),_c('navbar',{attrs:{"getSchoolName":_vm.getSchoolName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }